export const PROFILES_TOKEN = 'PROFILES';

export const PROFILES_API_PATHS = {
};
